import $ from 'jquery';

export default () => {
  const $form = $('form.search');

  // Enabling dropdown
  $form.find('.ui.dropdown').dropdown({
    onChange: () => $form.submit(),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/search.js